import { render, staticRenderFns } from "./RelativeFiles.vue?vue&type=template&id=b6626f7c&scoped=true"
import script from "./RelativeFiles.vue?vue&type=script&lang=js"
export * from "./RelativeFiles.vue?vue&type=script&lang=js"
import style0 from "./RelativeFiles.vue?vue&type=style&index=0&id=b6626f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6626f7c",
  null
  
)

export default component.exports